<template>
  <div class="container mt-5">
    <div class="row">
      <div class="col-0 col-md-2" />
      <!-- Na verzenden komt de gebruiker hier zonder dat er iets focus krijgt.
           role="status" zorgt dat een schermlezer de bevestiging voorleest;
           tabindex maakt hem bovendien een landingsplek voor de focus. -->
      <div class="card text-bg-primary col-12 col-md-8" role="status" tabindex="-1" ref="bevestiging">
        <div v-if="confirmSubmitText[lang]" class="card-body" :innerHTML="confirmSubmitText[lang]"></div>
        <div v-if="!confirmSubmitText[lang]" class="card-body">
          <h1 class="card-title h2">Dank voor uw aanmelding!</h1>
          <p class="card-text">Wij hebben u een bevestiging van uw deelname per e-mail verstuurd. Hierin vindt u alle
            informatie die u nodig heeft met een link naar het programma.</p>
          <p class="card-text">Wij kijken uit naar uw deelname!</p>
          <p v-if="confirmSignature" class="card-text"><b>{{ confirmSignature }}</b></p>
        </div>
      </div>
      <div class="col-0 col-md-2" />
    </div>
  </div>
</template>

<script>
import ServiceFactory from '../services/ServiceFactory'

export default {
  name: 'ConfirmSubmitPage',
  props: ['lang'],
  data() {
    return {
      isDynamicText: false,
      confirmSignature: (window.__APP_CONFIG__ || {}).confirmSignature || '',
      confirmSubmitText: {},
      formStructure: null,
      service: null
    }
  },
  watch: {
    formStructure(value) {
      if (value) {
        if (value.confirmSubmitText) {
          this.confirmSubmitText = value.confirmSubmitText
          this.isDynamicText = true
        }
      }
    }
  },
  methods: {
    checkAvailabilityContent(formStructure) {
      return formStructure && formStructure.confirmSubmitText
    }
  },
  async mounted() {
    // Ook hier een eigen titel: bij verzenden wisselt de pagina, en de titel is
    // wat een schermlezer als eerste noemt.
    const app = (window.__APP_CONFIG__ || {}).appName || 'ProjectenMonitor'
    document.title = `Aanmelding verzonden — ${app}`
    this.$refs.bevestiging?.focus()
    this.service = ServiceFactory.getService('formSubmit')
    this.formId = this.$route.query.id;
    this.formStructure = await this.service.getForm(this.formId)
  }
}
</script>